import React from 'react';
import DynamicTable, { type DynamicTableProps } from '@atlaskit/dynamic-table';
import Lozenge from '@atlaskit/lozenge';
import { Box, Flex, Text, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import { useIntl } from '@atlassian/jira-intl';
import { messages } from './messages.tsx';
import { getPriorities } from './utils.tsx';

export const PriorityTable = () => {
	const { formatMessage } = useIntl();
	const Priorities = getPriorities(formatMessage);

	const rows: DynamicTableProps['rows'] = Object.values(Priorities).map((priority, index) => ({
		key: `row-${index}`,
		cells: [
			{
				key: `cell-${index}-priority-in-Opsgenie`,
				content: (
					<Box paddingInlineStart="space.100" paddingBlock="space.150">
						<Lozenge
							// eslint-disable-next-line jira/react/no-style-attribute
							style={{
								backgroundColor: priority.bgColor,
								// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
								color: token('color.text.inverse'),
							}}
						>
							{priority.ogPriority}
						</Lozenge>
					</Box>
				),
			},
			{
				key: `cell-${index}-priority-in-Jira`,
				content: (
					<Flex justifyContent="end">
						<Flex columnGap="space.050" alignItems="center" xcss={priorityInJiraCellStyles}>
							<Flex xcss={IconContainer} alignItems="center" justifyContent="center">
								{priority.Icon}
							</Flex>
							<Text as="p">{priority.jiraPriority}</Text>
						</Flex>
					</Flex>
				),
			},
		],
	}));

	const head = {
		cells: [
			{
				key: 'priority-in-Opsgenie',
				content: (
					<Box paddingInlineStart="space.100">
						{formatMessage(messages.priortiyInOpsgenieNonFinal)}
					</Box>
				),
			},
			{
				key: 'priority-in-Jira',
				content: (
					<Flex justifyContent="end">
						<Box xcss={priorityInJiraHeadStyles}>
							{formatMessage(messages.priortiyInJiraNonFinal)}
						</Box>
					</Flex>
				),
			},
		],
	};

	return <DynamicTable head={head} rows={rows} isFixedSize />;
};

// In order to place priority in Jira column to the right, we need to set the width of the column.
const priorityInJiraHeadStyles = xcss({
	width: '127px',
});

const priorityInJiraCellStyles = xcss({
	width: '127px',
	paddingInlineStart: 'space.100',
});

const IconContainer = xcss({
	width: '20px',
	height: '20px',
});
